















import Vue from 'vue';
import Component from 'vue-class-component';

/**
 *  Rendering the selected icon (green circle and white checkmark).
 */
@Component
export default class Selected extends Vue {}
